import { post } from '@webapp-next/lib/request/webapp/http';
import { WebappApiResponse } from '@/lib/types/request/request';
import { CustomField } from '@/modules/people/types/people-setup';
import { DeputyAPIQueryBody } from '@/lib/types/request/deputy';

export default async function customFieldsConfigGet(): Promise<
  WebappApiResponse<CustomField[], unknown>
> {
  const body: Partial<DeputyAPIQueryBody> = {
    search: { System: { field: 'System', type: 'eq', data: 'Employee' } },
  };

  const options = {
    headers: {
      'dp-meta-option': 'none',
    },
  };

  try {
    const { data } = await post<
      Partial<DeputyAPIQueryBody>,
      { data: CustomField[] }
    >('api/v1/resource/CustomField/QUERY', body, options);

    return {
      success: true,
      message: '',
      data: data || [],
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
